import { space, SpaceProps } from 'styled-system';
import { applyTransientProps, PrependDollar } from './styled-system-helpers';

/**
 * margin, margin-left, margin-right, margin-top, margin-bottom
 * padding, padding-left, padding-right, padding-top, padding-bottom
 */
export type StyledSpaceProps = PrependDollar<SpaceProps>;

export const styledSpace = <T extends StyledSpaceProps>(props: T) => applyTransientProps(props, space);
